import i18next from "i18next";
import { useEffect } from "react";

export default function LanguageSelect({ changeLanguage, defaultValue }) {
    
    const handleLanguageChange = (value) => {
        console.log("event.target.value")
        console.log(value)
        changeLanguage(value)
    };

    useEffect(() => {
      console.log("i18next.language")
      console.log(i18next.language)
      if (i18next.language.indexOf('-') > -1) {
        handleLanguageChange(i18next.language.split('-')[0])
      } else {
        handleLanguageChange(i18next.language)
      }
    }, [])

    return (
        <select onChange={(e) => handleLanguageChange(e.target.value)} value={defaultValue}
        style={{
          fontSize: '16px',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '5px',
        }}
      >
        <option value="en">🇺🇸 English</option>
        <option value="es">🇪🇸 Español</option>
        <option value="pt">🇧🇷 Português</option>
      </select>
    )
}